import styled from '@emotion/styled/macro'
import React, { memo, useEffect, useState } from 'react'
import { AXIOS } from '../../utils/axios'
import { useGlobalContext } from '../../context'
import { Play, Stop } from '../../assets/icons'

const Card = memo(function Card({ genre, artist, server_url, title, server_name, color }) {
  const [img, setImg] = useState('')
  const [imgError, setImgError] = useState(false)
  const { setActiveGenre, activeGenre, hasChange, isPlaying, setIsPlaying } = useGlobalContext()

  const getImages = () => {
    AXIOS.get(`/${genre}/img`, { responseType: 'blob' })
      .then((response) => {
        if (response.status === 200) {
          setImg(URL.createObjectURL(response.data))
          setImgError(false)
        }
      })
      .catch((err) => {
        console.log(err)
        setImgError(true)
      })
  }
  useEffect(() => {
    const timeout = setTimeout(getImages, 500)
    return () => clearTimeout(timeout)
    //eslint-disable-next-line
  }, [])

  const getActiveMusicImg = () => {
    AXIOS.get(`/${activeGenre.genre}/img`, { responseType: 'blob' })
      .then((response) => {
        if (response.status === 200) {
          setImg(URL.createObjectURL(response.data))

          setActiveGenre({
            artist: activeGenre.artist,
            genre: activeGenre.genre,
            server_name: activeGenre.server_name,
            server_url: activeGenre.server_url,
            title: activeGenre.title,
            img: URL.createObjectURL(response.data),
          })
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  useEffect(() => {
    if (activeGenre.genre === genre && true) {
      getActiveMusicImg()
    }
    //eslint-disable-next-line
  }, [hasChange])

  const styles = {
    isActive: activeGenre.genre === genre && isPlaying,
    background: color,
  }

  return (
    <Wrapper
      styles={styles}
      onClick={() => {
        setActiveGenre({
          genre,
          artist,
          server_url,
          title,
          server_name,
          img,
        })

        setIsPlaying(true)
        if (styles.isActive) {
          setIsPlaying(false)
        }
      }}
    >
      <div className='half flex-column gap-1'>
        <h2>{server_name}</h2>
        <h3>{title?.split('-')[1]}</h3>
        <h4>{title?.split('-')[0]}</h4>
      </div>
      {img && !imgError ? (
        <img
          src={img}
          alt={server_name}
          onError={() => setImgError(true)}
        />
      ) : (
        <div className='art-fallback'>{server_name}</div>
      )}
      <i className='icon'>{styles.isActive ? <Stop /> : <Play />}</i>
    </Wrapper>
  )
})
export default Card

const Wrapper = styled('article')(({ styles: { isActive, background } }) => ({
  background,
  width: '100%',
  height: '150px',
  borderRadius: 'var(--radius)',
  position: 'relative',
  overflow: 'hidden',
  padding: '1rem',
  transition: '.5s all',
  cursor: 'pointer',
  boxShadow: isActive ? '0px 0px 20px var( --black-player-500)' : 'unset',
  '.half': {
    cursor: 'pointer',
    paddingRight: '.5rem',
    maxWidth: '50%',
    h2: {
      color: 'var(--text-50)',
      fontFamily: 'var(--primary-bold)',
      fontSize: '1rem',
    },
    h3: { color: 'var(--text-50)', fontSize: '.8em' },
    h4: { color: 'var(--text-50)', fontSize: '.7rem' },
  },

  'img, .art-fallback': {
    borderRadius: 'var(--radius)',
    position: 'absolute',
    width: isActive ? '150px' : '125px',
    height: isActive ? '100%' : '150px',
    bottom: '0',
    left: '100%',
    transform: isActive ? 'translate(-100%,0%) rotate(0deg)' : 'translate(-85%,5%) rotate(25deg)',
    boxShadow: '0px 0px 10px black',
    transition: '.5s all',

    borderTopLeftRadius: isActive && '0',
    borderBottomLeftRadius: isActive && '0',
  },
  '.art-fallback': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '.5rem',
    fontSize: '1.1rem',
    fontFamily: 'var(--primary-bold)',
    color: 'var(--text-50)',
    background,
  },
  '.icon': {
    visibility: isActive ? 'visible' : 'hidden',
    background: 'var(--primary-player)',
    display: 'grid',
    placeItems: 'center',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    position: 'absolute',
    bottom: '0',
    left: '100%',
    transform: 'translate(-250%,-130%) rotate(0deg)',
    cursor: 'pointer',
    svg: {
      cursor: 'pointer',
      fill: 'var(--text-50)',
      stroke: 'var(--text-50)',
      width: '20px',
    },
  },
  ':hover': {
    'img, .art-fallback': {
      transform: 'translate(-100%,0%) rotate(0deg)',
      height: '100%',
      width: '150px',
      borderTopLeftRadius: '0',
      borderBottomLeftRadius: '0',
    },
    '.icon': {
      visibility: 'visible',
    },

    boxShadow: '0px 0px 20px var( --black-player-500)',
  },
}))
